import React from "react";

const TerraceIcon = ({ className = "" }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    fill="none"
    viewBox="0 0 24 25"
    className={className}
  >
    <path
      stroke="#354052"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M3 12.325h1m8-9v1m8 8h1m-15.4-6.4.7.7m12.1-.7-.7.7m-9.7 5.7a4 4 0 1 1 8 0m-13 4h18m-18 4h18"
    ></path>
  </svg>
);

export default TerraceIcon;
